import { OpenInNew } from '@mui/icons-material'
import { Stack } from '@mui/material'
import { MouseEvent, PropsWithChildren } from 'react'

type Props = {
  enabled?: boolean
}

export const HoverLinkWrapper = ({ children, enabled = true }: PropsWithChildren<Props>) => {
  const suppressParentLinkNavigation = enabled
    ? (event: MouseEvent) => {
        event.preventDefault()
      }
    : undefined

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onClickCapture={suppressParentLinkNavigation}
      sx={{
        cursor: enabled ? 'pointer' : 'default',
        borderRadius: 1,
        padding: 1,
        maxWidth: '100%',
        '&:hover': enabled
          ? {
              backgroundColor: 'neutralLight.300',
            }
          : {},
      }}
      className="hover-link-wrapper"
    >
      {children}
      <OpenInNew
        sx={{
          width: 16,
          height: 16,
          marginLeft: 1,
          color: 'neutralLight.700',
          display: 'none',
          '.hover-link-wrapper:hover > &': enabled
            ? {
                display: 'block',
              }
            : {},
        }}
      />
    </Stack>
  )
}
